import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Home from "../pages/Home/Home";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import ProjectDetails from "../pages/ProjectDetails/ProjectDetails";
import About from "../pages/About/About";
import PasswordGate from "../components/PasswordGate/PasswordGate";

function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Intenta ambos
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, search]);

  return null;
}

export default function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <PasswordGate>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<ProjectDetails />} />
          <Route path="/about" element={<About />} />
        </Routes>
        <Footer />
      </PasswordGate>
    </BrowserRouter>
  );
}